import { render, staticRenderFns } from "./ReceiptsTable.vue?vue&type=template&id=8553f47a&scoped=true&"
import script from "./ReceiptsTable.vue?vue&type=script&lang=ts&"
export * from "./ReceiptsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptsTable.vue?vue&type=style&index=0&id=8553f47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8553f47a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
